<template>
  <div class="upload">
    <el-upload
      :show-file-list="false"
      :action="action"
      :headers="headers"
      list-type="picture-card"
      :on-preview="onPreview"
      :before-upload="beforeAvatarUpload"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :accept="accept"
      :data="otherParams"
      :multiple="multiple"
    >
      <img class="show-image" v-if="imageUrl" :src="imageUrl" alt="" />
      <i v-else class="el-icon-plus"></i>
    </el-upload>
    <el-dialog v-model  = "dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import config from "@/config";

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    accept: {
      type: String,
      default: "image/jpeg,image/jpg,image/png",
    },
    action: {
      type: String,
      default: process.env.VUE_APP_TARGET_TVRJET_THIRD + "/obs/thirdParty/uploadFile",
    },
    otherParams: {
      type: Object,
      default: function () {
        return { oldUrl: "" };
      },
    },
    /* headers:{ */
    /*     type:Object, */
    /*     default:function(){ */
    /*         return {'Authorization':this.token} */
    /*     } */
    /* }, */
    multiple: {
      type: Boolean,
      default: false,
    },
    /* limit: { */
    /*    type: Number, */
    /*    default: 1 */
    /* } */
  },
  data() {
    return {
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.user.token,
    }),
    imageUrl() {
      return this.value;
    },
    headers() {
      /* return {'Authorization':this.token} */
      return { AppSecretKey: "XtJMTI2e3fRChHA8vg7rUSN4dZKyD0FWuOY6" };
    },
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG、JPEG、PNG 格式!");
        return isJPG;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 5MB!");
        return isLt2M;
      }
      return isJPG && isLt2M;
    },
    onRemove(file, fileList) {
      /* console.log(file, fileList); */
    },
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    onSuccess(response, file, fileList) {
      /* console.log(file,fileList) */
      /* this.value=response.data[0] */
      this.$emit("input", response.data[0]);
    },
  },
};
</script>

<style lang="less" scoped>
.upload {
  .show-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
